
import React, { Component } from "react";
import Modal from "../../../styled-base/modal";
import ModalHeader from "../../../components/modals/commons/modalHeader";
import GoalProgressBar from "../../../components/okr/okr_depend_components/goalProgressBar.component";
import LoaderComp from "../LoaderComp";
import debounce from "lodash/debounce";
import "./orgResultsDialogs.scss"
import { withTranslation } from "react-i18next";

const resultColors = {
    top: "#4da449",
    bottom: "#e05238"
}

class OrgResultsDialog extends Component< any, any > {
    private popupScrollContainer: any;
    constructor(props: any){
        super(props);
        this.state = {
            showLoader: false
        }
        this.popupScrollContainer = React.createRef();
    }
    
    componentDidMount(){
        const El = this.popupScrollContainer.current;
        El.addEventListener("scroll", this.handleScroll );
    }

    handleScroll = () => {
        const El = this.popupScrollContainer.current;
        this.setState({
            showLoader: true
        })
        this.props.handlePopupScroll(this.props.modalData.type, El)
        //debounce(() => this.props.handlePopupScroll(this.props.modalData.type, El), 20);
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.showLoader && this.props.popupData != prevProps.popupData){
            this.setState({
                showLoader: false
            })
        }
        if(this.props.popupData.isAllFetched){
            const El = this.popupScrollContainer.current;
            El.removeEventListener("scroll", this.handleScroll );
        }
    }

    render(){
    const { modalData, popupData, t } = this.props;

    return (
            <div>
                <section className="modal-backdrop"></section>
                <Modal 
                    // isFixed={true}
                    width={980}
                    // minHeight="250px"
                    // maxHeight="550px"
                    // height="auto"
                    id="orgResultsDialog"
                    //position={{ x: '12%', y: '22%' }}
                    transform_property={true}
                    transform_property_lm={false}>
                    <div className={`wbmodal orgResultsPopup`} style={{maxHeight:"550px"}}>
                        <ModalHeader 
                            title = {modalData.title}
                            closePopup = {this.props.closePopup}
                            button = {modalData.btn && popupData &&  popupData.data.length >0 ? {
                                label: modalData.btn.label,
                                iconClass: modalData.btn.iconClass, 
                                onClick: () => modalData.btn.onClick(this.props.forData)
                            } : null}
                        />
                        <div className="wbmodal-content" style={{maxHeight:"395px"}} ref={this.popupScrollContainer}>
                            <div className={`table ${modalData.type}`} >
                                <div className="header">
                                    <span>
                                        {t('Team Name')}
                                    </span>
                                    <span>
                                        {t('Team Lead')}
                                    </span>
                                    <span>
                                        {t('Reports To')}
                                    </span>
                                    {
                                        (modalData.type !== "zero" && modalData.type !== "hundred") &&
                                        <span>
                                            {t('Results')}
                                        </span>
                                    }
                                    {
                                        modalData.type === "top" && popupData &&  popupData.data.length >0 && popupData.data[0].showBadge ==1  &&
                                        <span>
                                            {t('Badge')}
                                        </span>
                                    }
                                    {
                                        (modalData.type === "zero" || modalData.type === "hundred") &&
                                        <span>
                                            {`# of ${t('OKRs')}`}
                                        </span>
                                    }
                                    {
                                        (modalData.type === "zero" || modalData.type === "hundred") &&
                                        <span>
                                            # {t('of members')}
                                        </span>
                                    }
                                </div>
                                <div className="sep">
                                </div>
                                {
                                    popupData &&
                                        popupData.data.map((item) => 
                                        <div className="row" key={item.id}>
                                            <a href={`/wb/goal/teamGoal?teamId=${item.id}&js=1`} target="_blank" title={item.team_name}>
                                                <span>
                                                    {item.team_name}
                                                </span>
                                            </a>
                                            <a href={`/wb/memberProfile/index?id=${item.team_leader_id}`} target="_blank" title={item.team_leader}>
                                                <span>
                                                    {item.team_leader}
                                                </span>
                                            </a>
                                            <a href={`/wb/memberProfile/index?id=${item.reports_to_id}`} style={{pointerEvents: item.reports_to_id === 0 ? "none": "inherit"}} target="_blank" title={item.reports_to}>
                                                <span>
                                                    {item.reports_to}
                                                </span>
                                            </a>
                                            {
                                                modalData.type !== "zero" && modalData.type !== "hundred" &&
                                                <span>
                                                    <GoalProgressBar
                                                    percentage={item.progress}
                                                    color={item.color}
                                                    title={`${t('Results for')} ${item.team_name}, ${('with')} ${item.number_okr} ${item.number_okr == 0 || item.number_okr == 1 ? t("OKR") : t("OKRs and")} ${item.number_members} ${item.number_members == 0 || item.number_members == 1 ? t("member") : t("members")}`}
                                                    style={{
                                                        width: "calc(100% - 50px)",
                                                        marginTop: "0px",
                                                        fontSize: 12,
                                                        lineHeight: "10px"
                                                    }}
                                                    />
                                                </span>
                                            }
                                            {
                                                modalData.type === "top" && item.showBadge ==1 &&
                                                <span title="Give badge" className="badge" id="orgResultsBadge" data-team-id={item.id}>
                                                </span>
                                            }
                                            {
                                                (modalData.type === "zero" || modalData.type === "hundred") &&
                                                <span style={{pointerEvents: "none"}}>
                                                    {item.number_okr} {item.number_okr == 0 || item.number_okr == 1 ? t("OKR") : t("OKRs")}
                                                </span>
                                            }
                                            {
                                                (modalData.type === "zero" || modalData.type === "hundred") &&
                                                <span style={{pointerEvents: "none"}}>
                                                    {item.number_members} {item.number_members == 0 || item.number_members == 1 ? t("member") : t("members")}
                                                </span>
                                            }
                                        </div>
                                        )
                                }
                                {
                                    this.state.showLoader ? <LoaderComp /> : ""
                                }
                            </div>
                        </div>
                        {/* <ModalFooter
                            addItem = {this.addItem}
                            buttonLabel = {buttonLabel}
                            closePopup = {this.props.closePopup}
                            itemsLength = {itemsLength}
                        /> */}
                    </div>
                </Modal>
                <div  id="org-popup-container"></div>
            </div>
        );
    }
}

export default withTranslation()(OrgResultsDialog);
